import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PLANTILLASCONTABILIDAD_LISTA, PLANTILLASCONTABILIDAD_NUEVO } from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'

export default function AsientosContablesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PLANTILLASCONTABILIDAD_NUEVO}/:id`} component={NuevoPage} />
        <Route path={`/${PLANTILLASCONTABILIDAD_NUEVO}`} component={NuevoPage} />
        <Route path={`/${PLANTILLASCONTABILIDAD_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
